import { render, staticRenderFns } from "./TheMeasuresChart.vue?vue&type=template&id=bd2abed2&scoped=true&"
import script from "./TheMeasuresChart.vue?vue&type=script&lang=js&"
export * from "./TheMeasuresChart.vue?vue&type=script&lang=js&"
import style0 from "./TheMeasuresChart.vue?vue&type=style&index=0&id=bd2abed2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2abed2",
  null
  
)

export default component.exports